// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".playlist_root__BXCow {\n  width: 100%;\n  height: calc(100vh - 364px); }\n\n@media screen and (max-width: 800px) {\n  .playlist_root__BXCow {\n    height: calc(100vh - 315px); } }\n\n@media screen and (max-width: 600px) {\n  .playlist_root__BXCow {\n    height: calc(100vh - 265px); } }\n\n@media screen and (max-width: 400px) {\n  .playlist_root__BXCow {\n    height: calc(100vh - 220px); } }\n", ""]);
// Exports
exports.locals = {
	"root": "playlist_root__BXCow"
};
module.exports = exports;
